import _findIndex from 'lodash/findIndex';
import { handleActions } from 'redux-actions';
import { userModalActions } from 'components/usersModal';
import { twilioActions } from '../../../app/middleware/twilio/actions/twilioActions';
import * as conversationActions from '../../conversation/actions/conversation';
import { actions } from '../actions/telephony';
const { conversationCloseSucceeded, conversationWsClose, conversationOutboundStarted, } = conversationActions.actions;
const { twilioEstablishedCall, twilioDisconnectedCall, twilioChangeDeviceStatus, } = twilioActions;
export const { telephonyGetUsersByQuery, telephonyGetUsersByQuerySucceeded, telephonyGetUsersByQueryFailed, telephonyGetAllCountryCodes, telephonyGetAllCountryCodesSucceeded, telephonyGetAllCountryCodesFailed, telephonyResetUsers, telephonyRenewToken, telephonyRenewTokenSucceeded, telephonyRenewTokenFailed, telephonyGetAllOwnNumbers, telephonyGetAllOwnNumbersSucceeded, telephonyGetAllOwnNumbersFailed, telephonyGetDefaultNumber, telephonyGetDefaultNumberSucceeded, telephonyGetDefaultNumberFailed, telephonySetBlocked, telephonyOpenDropdown, telephonyCloseDropdown, telephonySetHold, telephonySetHoldSucceeded, telephonySetHoldFailed, telephonySetMute, telephonySetMuteSucceeded, telephonySetMuteFailed, telephonyChangeFromNumber, telephonyGetQueryNumbers, telephonyGetQueryNumbersSucceeded, telephonyGetQueryNumbersFailed, telephonySetSearchValue, telephonyResetHold, } = actions;
export const initialState = {
    meta: {
        asyncStatus: 'succeeded',
        usersAsyncStatus: 'succeeded',
        dynamicTelephoneNumbersArrayAsyncStatus: 'succeeded',
        staticTelephoneNumbersArrayAsyncStatus: 'succeeded',
        allCountryCodesAsyncStatus: 'succeeded',
        defaultNumberAsyncStatus: 'succeeded',
        mute: 'succeeded',
        hold: 'succeeded',
    },
    ui: {
        isTelephonyDropdownOpen: false,
    },
    selectedFromNumber: null,
    token: null,
    isOnHold: false,
    isOnMute: false,
    isReady: true,
    searchValue: '',
    isMicrophoneBlocked: false,
    users: [],
    dynamicTelephoneNumbersArray: [],
    staticTelephoneNumbersArray: [],
    allCountryCodes: [],
    currentCall: null,
    previousPage: null,
    nextPage: null,
};
const telephony = handleActions({
    [telephonyResetHold.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { mute: 'succeeded', hold: 'succeeded' }), isOnHold: false });
    },
    [telephonyChangeFromNumber.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { selectedFromNumber: action.payload.number });
    },
    [telephonyResetUsers.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { usersAsyncStatus: 'succeeded' }), users: [] });
    },
    [telephonyGetAllCountryCodes.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { allCountryCodesAsyncStatus: 'loading' }) });
    },
    [telephonySetSearchValue.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { searchValue: action.payload !== undefined ? action.payload : '' });
    },
    [telephonyGetAllCountryCodesSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { allCountryCodesAsyncStatus: 'succeeded' }), allCountryCodes: action.payload.data.countries });
    },
    [telephonyGetAllCountryCodesFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { allCountryCodesAsyncStatus: 'failed' }) });
    },
    [telephonySetHold.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { hold: 'loading' }) });
    },
    [telephonySetHoldSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isOnHold: action.payload.meta.request, meta: Object.assign(Object.assign({}, state.meta), { hold: 'succeeded' }) });
    },
    [telephonySetHoldFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { hold: 'failed' }) });
    },
    [telephonySetMute.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { mute: 'loading' }) });
    },
    [telephonySetMuteSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { mute: 'succeeded' }), isOnMute: action.payload.meta.request });
    },
    [telephonySetMuteFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { mute: 'failed' }) });
    },
    [telephonyGetQueryNumbers.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { dynamicTelephoneNumbersArrayAsyncStatus: 'loading' }) });
    },
    [telephonyGetQueryNumbersSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { dynamicTelephoneNumbersArrayAsyncStatus: 'succeeded' }), dynamicTelephoneNumbersArray: action.payload.data &&
                Array.isArray(action.payload.data.numbers) === true
                ? action.payload.data.numbers
                : [], nextPage: action.payload.meta ? action.payload.meta.next_page : null, previousPage: action.payload.meta
                ? action.payload.meta.prev_page
                : null });
    },
    [telephonyGetQueryNumbersFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { dynamicTelephoneNumbersArrayAsyncStatus: 'failed' }) });
    },
    [telephonyGetAllOwnNumbers.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { staticTelephoneNumbersArrayAsyncStatus: 'loading' }) });
    },
    [telephonyGetAllOwnNumbersSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { staticTelephoneNumbersArrayAsyncStatus: 'succeeded' }), staticTelephoneNumbersArray: action.payload.data &&
                Array.isArray(action.payload.data.numbers) === true
                ? action.payload.data.numbers
                : [] });
    },
    [telephonyGetAllOwnNumbersFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { staticTelephoneNumbersArrayAsyncStatus: 'failed' }) });
    },
    [telephonyGetDefaultNumber.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { defaultNumberAsyncStatus: 'loading' }) });
    },
    [telephonyGetDefaultNumberSucceeded.toString()]: (state, action) => {
        var _a;
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { defaultNumberAsyncStatus: 'succeeded' }), selectedFromNumber: ((_a = action.payload.data) === null || _a === void 0 ? void 0 : _a.e164_format)
                ? action.payload.data
                : null });
    },
    [telephonyGetDefaultNumberFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { defaultNumberAsyncStatus: 'failed' }) });
    },
    [telephonyGetUsersByQuery.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { usersAsyncStatus: 'loading' }) });
    },
    ['TELEPHONY_BUY_NUMBER_SUCCEEDED']: (state, action) => {
        var _a;
        const newNumber = ((_a = action.payload.result) === null || _a === void 0 ? void 0 : _a.data)
            ? Object.assign({}, action.payload.result.data)
            : null;
        if (newNumber) {
            return Object.assign(Object.assign({}, state), { staticTelephoneNumbersArray: [
                    ...state.staticTelephoneNumbersArray,
                    newNumber,
                ] });
        }
        return state;
    },
    [telephonyGetUsersByQuerySucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { usersAsyncStatus: 'succeeded' }), users: Array.isArray(action.payload.data) === true &&
                action.payload.data[0] !== undefined &&
                action.payload.data[0].hits !== undefined
                ? action.payload.data[0].hits
                : [] });
    },
    [telephonyGetUsersByQueryFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { usersAsyncStatus: 'failed' }) });
    },
    [telephonyRenewToken.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [telephonyRenewTokenSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }), token: action.payload.data.token });
    },
    [telephonyRenewTokenFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }), token: null });
    },
    [telephonyOpenDropdown.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isTelephonyDropdownOpen: true }) });
    },
    [telephonyCloseDropdown.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isTelephonyDropdownOpen: false }) });
    },
    // USER MODAL ACTIONS.
    [userModalActions.user.update.pending.type]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { usersAsyncStatus: 'loading' }) });
    },
    // We need to update based on userModal action.
    [userModalActions.user.update.fulfilled.type]: (state, action) => {
        const { payload: { data: updatedUser }, } = action;
        const users = state.users.slice();
        const index = _findIndex(users, { id: updatedUser.id });
        if (index > -1) {
            users[index] = updatedUser;
        }
        return Object.assign(Object.assign({}, state), { users: users, meta: Object.assign(Object.assign({}, state.meta), { usersAsyncStatus: 'succeeded' }) });
    },
    // We need to update based on userModal action.
    [userModalActions.user.update.rejected.type]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { usersAsyncStatus: 'failed' }) });
    },
    [telephonySetBlocked.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { isMicrophoneBlocked: true });
    },
    [twilioChangeDeviceStatus.toString()]: (state, action) => {
        console.warn('action', action.payload);
        return Object.assign(Object.assign({}, state), { isReady: action.payload._status === 'ready' ||
                action.payload.state === 'registered' });
    },
    [twilioDisconnectedCall.toString()]: (state, action) => {
        var _a;
        let currentCall = state.currentCall;
        let isOnMute = state.isOnMute;
        let isOnHold = state.isOnHold;
        const { conference } = action.payload.message;
        if (conference &&
            currentCall &&
            conference.toString() === ((_a = currentCall.csid) === null || _a === void 0 ? void 0 : _a.toString())) {
            currentCall = null;
            isOnMute = false;
            isOnHold = false;
        }
        return Object.assign(Object.assign({}, state), { currentCall: currentCall, isOnHold: isOnHold, isOnMute: isOnMute });
    },
    [twilioEstablishedCall.toString()]: (state, action) => {
        let currentCall = state.currentCall;
        let isOnMute = state.isOnMute;
        const { csid, muted } = action.payload;
        if (csid) {
            if (muted === 'true') {
                isOnMute = true;
            }
            currentCall = {
                csid: csid,
            };
        }
        return Object.assign(Object.assign({}, state), { currentCall: currentCall, isOnMute: isOnMute });
    },
    [conversationOutboundStarted.toString()]: (state, action) => {
        let currentCall = state.currentCall;
        const { csid, channel, enduser } = action.payload;
        if (channel === 'pstnphone') {
            currentCall = {
                csid: csid,
                enduser: enduser,
            };
        }
        return Object.assign(Object.assign({}, state), { currentCall: currentCall });
    },
    [conversationWsClose.toString()]: (state, action) => {
        let currentCall = state.currentCall;
        let isOnMute = state.isOnMute;
        let isOnHold = state.isOnHold;
        // Close if the call is conference and we know this csid in telephony.
        if ((currentCall === null || currentCall === void 0 ? void 0 : currentCall.csid) &&
            currentCall.csid === action.payload.params.csid) {
            currentCall = null;
            isOnMute = false;
            isOnHold = false;
        }
        return Object.assign(Object.assign({}, state), { currentCall: currentCall, isOnMute: isOnMute, isOnHold: isOnHold });
    },
    [conversationCloseSucceeded.toString()]: (state, action) => {
        let currentCall = state.currentCall;
        let isOnMute = state.isOnMute;
        let isOnHold = state.isOnHold;
        // Close if the call is conference and we know this csid in telephony.
        if ((currentCall === null || currentCall === void 0 ? void 0 : currentCall.csid) && currentCall.csid === action.payload.data.id) {
            currentCall = null;
            isOnMute = false;
            isOnHold = false;
        }
        return Object.assign(Object.assign({}, state), { currentCall: currentCall, isOnMute: isOnMute, isOnHold: isOnHold });
    },
}, initialState);
export default telephony;
